import { useState } from "react";

export default function YourMealsForm({ prefs, onSubmit, btnText }) {
    const [form, setForm] = useState({
      servings: prefs.servings,
      cookingFor: prefs.cookingFor,
      dietaryRestrictions: prefs.dietaryRestrictions,
      dietaryGoals: prefs.dietaryGoals,
      dislikes: prefs.dislikes,
    });
    const buttonText = btnText || "Save";
    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  
    const handleSubmit = (e) => {
      e.preventDefault();
      onSubmit({ ...prefs, ...form });
    };
  
    return (
      <form onSubmit={handleSubmit} className="space-y-4">
        <InputField
          label="Default number of servings"
          name="servings"
          type="number"
          value={form.servings}
          onChange={handleChange}
        />
        <SelectField
          label="Who are you cooking for?"
          name="cookingFor"
          value={form.cookingFor}
          onChange={handleChange}
          options={[
            { value: "adults", label: "Adults" },
            { value: "children", label: "Children" },
            { value: "family", label: "A family" },
          ]}
        />
        <InputField
          label="Dietary restrictions"
          name="dietaryRestrictions"
          value={form.dietaryRestrictions}
          onChange={handleChange}
          placeholder="e.g. vegetarian, nuts"
        />
        <InputField
          label="Dietary goals"
          name="dietaryGoals"
          value={form.dietaryGoals}
          onChange={handleChange}
          placeholder="e.g. high fibre, low calorie"
        />
        <InputField
          label="Dislikes"
          name="dislikes"
          value={form.dislikes}
          onChange={handleChange}
          placeholder="e.g. olives, brussels sprouts"
        />
        <button className="w-full bg-sage text-white py-2 rounded-3xl hover:bg-sagedark">{buttonText}</button>
      </form>
    );
  }
  
  function InputField({ label, ...props }) {
    return (
      <label className="block">
        <span className="block mb-1">{label}</span>
        <input {...props} className="w-full p-2 bg-white border rounded" />
      </label>
    );
  }
  
  function SelectField({ label, options, ...props }) {
    return (
      <label className="block">
        <span className="block mb-1">{label}</span>
        <select {...props} className="w-full p-2 bg-white border rounded">
          {options.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      </label>
    );
  }
  